export default __webpack_public_path__ + "static/media/s-squiggle-96.1bd0d6d6.svg";